var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationTrocadepontos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration_troca_de_pontos",
    "data-name": "illustration_troca de pontos",
    xmlns: "http://www.w3.org/2000/svg",
    width: 395,
    height: 221,
    viewBox: "0 0 395 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17398",
    "data-name": "Rectangle 17398",
    width: 395,
    height: 221,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7715",
    "data-name": "Path 7715",
    d: "M367.27,205.55V190.36c0-9.73-.05-23.75-.08-41l.15.15-97.08.05h0l.2-.2v56.17l-.18-.18,69.83.09h20.14l-20,.05-69.95.09H270V149.02h97.45v.15c0,17.26-.06,31.31-.08,41.07v14.12A7,7,0,0,1,367.27,205.55Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7716",
    "data-name": "Path 7716",
    d: "M367.31,156.18c0,.11-21.72.2-48.5.2s-48.51-.09-48.51-.2,21.71-.2,48.51-.2S367.31,156.07,367.31,156.18Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17399",
    "data-name": "Rectangle 17399",
    width: 29.99,
    height: 29.99,
    transform: "translate(278.59 165.44)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7717",
    "data-name": "Path 7717",
    d: "M360.23,170.39a1.889,1.889,0,0,1-.44,0h-1.27l-4.65.06-15.34.06-15.35-.06-4.66-.06h-1.26a1.889,1.889,0,0,1-.44,0,1.889,1.889,0,0,1,.44,0h1.26l4.66-.06,15.35-.06,15.34.06,4.65.06h1.27a1.889,1.889,0,0,1,.44,0Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7718",
    "data-name": "Path 7718",
    d: "M361.2,177.09a2,2,0,0,1-.45,0h-1.3l-4.75.06-15.69.06-15.69-.06-4.76-.06h-1.29a1.939,1.939,0,0,1-.45,0,1.939,1.939,0,0,1,.45,0h1.29l4.76-.06,15.69-.06,15.69.06,4.75.06h1.3A2,2,0,0,1,361.2,177.09Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7719",
    "data-name": "Path 7719",
    d: "M361.2,183.79a2,2,0,0,1-.45,0h-1.3l-4.75.06L339,184l-15.69-.06-4.76-.06h-1.29a1.94,1.94,0,0,1-.45,0,1.939,1.939,0,0,1,.45,0h1.29l4.76-.06,15.69-.06,15.69.06,4.75.06h1.3a2,2,0,0,1,.46-.09Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7720",
    "data-name": "Path 7720",
    d: "M361.2,190.49a2,2,0,0,1-.45,0h-1.3l-4.75.06-15.69.06-15.69-.06-4.76-.06h-1.29a1.94,1.94,0,0,1-.45,0,1.939,1.939,0,0,1,.45,0h1.29l4.76-.06,15.69-.06,15.69.06,4.75.06h1.3A2,2,0,0,1,361.2,190.49Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7721",
    "data-name": "Path 7721",
    d: "M43.47,62.19a8.12,8.12,0,0,1-5.89-8.11c.1-1.63.71-3.22.64-4.85-.11-2.54-1.79-4.68-3.06-6.87s-2.11-5.1-.63-7.16c.95-1.34,2.64-1.94,3.8-3.11a12.41,12.41,0,0,0,2.28-4.22,7.24,7.24,0,0,1,2.79-3.82c1.4-.8,3.54-.44,4.11,1.06",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7722",
    "data-name": "Path 7722",
    d: "M58.6,21.1c-2.5-1.58-3.1-5.26-1.75-7.89A9.65,9.65,0,0,1,64,8.52,13.59,13.59,0,0,1,75.71,12.4c1.62,1.66,2.92,3.82,5.1,4.58,1.92.67,4,.07,6.06.33a9.16,9.16,0,0,1,6.41,4.62,19.79,19.79,0,0,1,2.27,7.78c.3,2.49.49,5.21,2.21,7s4.34,2.14,6.43,3.4a8.8,8.8,0,0,1,2.61,12c-.83,1.21-2,2.31-2.11,3.77s.77,2.52,1.17,3.79a5.93,5.93,0,0,1-5.07,7.37c-1.74.1-3.59-.57-5.15.2s-2.11,2.63-3.1,4a7.41,7.41,0,0,1-9.05,2.33C82.22,73,81,72,79.6,72.09s-2.53,1.3-3.92,1.57c-1.82.35-3.55-1-4.63-2.49s-1.84-3.28-3.23-4.51c-1.81-1.62-4.36-2-6.65-2.81A18.78,18.78,0,0,1,50.56,37.54",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7723",
    "data-name": "Path 7723",
    d: "M53.12,24.38a4,4,0,0,0-3.56,4.05h0l2.38,53.88c.1,6.36,9.4,9.94,16.21,9.78h0c6.88-.16,7.1-3.54,7.19-9.59.14-10.11.13-13.91.13-13.85s8.69-1.47,10.47-12.81c.88-5.64.58-14.89.09-22.45-.45-6.8-5-15.14-11.75-14.41Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7724",
    "data-name": "Path 7724",
    d: "M83.53,40.73a1.45,1.45,0,0,1-1.4,1.47,1.39,1.39,0,0,1-1.5-1.31A1.46,1.46,0,0,1,82,39.42a1.39,1.39,0,0,1,1.53,1.31Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7725",
    "data-name": "Path 7725",
    d: "M84,38.2c-.18.19-1.28-.62-2.85-.61s-2.71.79-2.88.6.1-.43.6-.79a4,4,0,0,1,2.3-.72,3.77,3.77,0,0,1,2.27.73C84,37.78,84.12,38.12,84,38.2Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7726",
    "data-name": "Path 7726",
    d: "M67.93,40.73a1.45,1.45,0,0,1-1.4,1.47A1.38,1.38,0,0,1,65,40.89a1.45,1.45,0,0,1,1.39-1.47,1.4,1.4,0,0,1,1.54,1.31Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7727",
    "data-name": "Path 7727",
    d: "M68.64,38.53c-.18.19-1.28-.62-2.85-.61s-2.71.79-2.88.6.1-.43.6-.8A4,4,0,0,1,65.82,37a3.89,3.89,0,0,1,2.27.72C68.57,38.1,68.73,38.45,68.64,38.53Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7728",
    "data-name": "Path 7728",
    d: "M74.35,50.13a10.43,10.43,0,0,1,2.54-.47c.4,0,.78-.12.85-.39a2.13,2.13,0,0,0-.27-1.19c-.38-1-.78-2-1.19-3-1.65-4.33-2.85-7.89-2.67-7.95s1.65,3.39,3.3,7.72c.4,1.07.78,2.08,1.14,3.06a2.34,2.34,0,0,1,.21,1.57,1,1,0,0,1-.65.58,3.1,3.1,0,0,1-.68.1,10.12,10.12,0,0,1-2.58-.03Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7729",
    "data-name": "Path 7729",
    d: "M75.47,68.65a28.84,28.84,0,0,1-15.2-4s3.85,8,15.2,6.91Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13680",
    "data-name": "Group 13680",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7730",
    "data-name": "Path 7730",
    d: "M71.32,56.2a6,6,0,0,0,2-1.2,1.83,1.83,0,0,0,.45-.47.53.53,0,0,0,0-.58",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7731",
    "data-name": "Path 7731",
    d: "M73.7,53.9a2.82,2.82,0,0,0-2.53-1,2.54,2.54,0,0,0-1.78,1,1.62,1.62,0,0,0-.12,1.86",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7732",
    "data-name": "Path 7732",
    d: "M69.75,51.22c.25,0,.26,1.68,1.72,2.89s3.26,1,3.27,1.24-.4.34-1.16.36a4.2,4.2,0,0,1-2.74-1,3.68,3.68,0,0,1-1.33-2.42C69.44,51.63,69.63,51.21,69.75,51.22Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7733",
    "data-name": "Path 7733",
    d: "M69.34,35.79c-.15.42-1.71.23-3.55.45s-3.32.73-3.57.35c-.1-.18.15-.58.75-1A6.23,6.23,0,0,1,68.39,35C69.07,35.25,69.41,35.59,69.34,35.79Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7734",
    "data-name": "Path 7734",
    d: "M83.44,33.68c-.27.35-1.35,0-2.65,0s-2.39.24-2.64-.13c-.12-.18.06-.53.54-.87a3.66,3.66,0,0,1,2.15-.59,3.75,3.75,0,0,1,2.12.71C83.41,33.14,83.57,33.5,83.44,33.68Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7735",
    "data-name": "Path 7735",
    d: "M60.56,20.69a11,11,0,0,0-9-1.69,7.64,7.64,0,0,0-5.63,6.68c-.07,2,.8,4.14-.09,5.94s-2.93,2.38-4.4,3.67a6.75,6.75,0,0,0-1.57,8.18c1.24,2.28,3.84,3.94,4.06,6.51.2,2.41-1.83,4.45-2.33,6.83-.54,2.62.91,5.33,3,7.06a23.15,23.15,0,0,0,7.27,3.62c2,.72,4.14,1.45,6.22,1a6.36,6.36,0,0,0,4.67-5.32,8.64,8.64,0,0,0-2.37-6.84c-1.45-1.61-3.5-3-3.85-5.09-.54-3.3,3.39-6,3.15-9.34-.13-1.72-1.34-3.14-2.35-4.55s-1.89-3.2-1.27-4.81c.81-2.1,3.56-2.64,5.23-4.18a5.11,5.11,0,0,0,1.39-5.16,5.24,5.24,0,0,0-4.11-3.5",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7736",
    "data-name": "Path 7736",
    d: "M59.34,18.13a7.76,7.76,0,0,0,9.16,7.66c1.73-.31,3.63-1.19,5.13-.27s1.64,3.35,3,4.57c2,1.73,5.18.1,7.72.86,2,.58,3.18,2.45,4.49,4s3.25,3.07,5.21,2.49a23,23,0,0,0-.78-5.23,7.69,7.69,0,0,0-3-4.26c-.81-.53-1.75-.85-2.51-1.46-1.62-1.31-2-3.6-3-5.43a8.49,8.49,0,0,0-6.48-4.3c-2.23-.23-4.53.44-6.71-.11-1.61-.4-3-1.45-4.64-1.76-3.17-.6-6.12,1.68-8.42,3.94",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7737",
    "data-name": "Path 7737",
    d: "M38.63,45.24a2.35,2.35,0,0,1-.26-1.3,3.29,3.29,0,0,1,2.29-2.61,14.91,14.91,0,0,1,2.49-.67A7.25,7.25,0,0,0,46,39.49a4,4,0,0,0,1.47-3,30.581,30.581,0,0,0-.17-3.57,7.78,7.78,0,0,1,.09-1.75A3.61,3.61,0,0,1,48,29.65a5.6,5.6,0,0,1,2.73-1.56,12.47,12.47,0,0,0,2.78-1.2,9.45,9.45,0,0,0,2.05-1.68,9.6,9.6,0,0,0,2-3.23,5.62,5.62,0,0,0,.29-1c0-.23.07-.36,0-.36s-.15.47-.5,1.29a10,10,0,0,1-6.8,5.79,6,6,0,0,0-2.93,1.67,4.16,4.16,0,0,0-.77,1.68,8.18,8.18,0,0,0-.09,1.85A33.339,33.339,0,0,1,47,36.43a3.61,3.61,0,0,1-1.29,2.75,7.14,7.14,0,0,1-2.66,1.13,16.46,16.46,0,0,0-2.53.73,4.12,4.12,0,0,0-1.76,1.32,3,3,0,0,0-.57,1.56,2,2,0,0,0,.2,1C38.52,45.16,38.62,45.25,38.63,45.24Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7738",
    "data-name": "Path 7738",
    d: "M105.43,52.32a.392.392,0,0,0,.19-.08,1.43,1.43,0,0,0,.43-.43,2.3,2.3,0,0,0-.23-2.24,3.07,3.07,0,0,0-1.22-1.17,18.459,18.459,0,0,0-1.82-.77,5.46,5.46,0,0,1-1.91-1.08,4.09,4.09,0,0,1-1.09-2.15c-.19-.85-.25-1.78-.4-2.75a6,6,0,0,0-1.13-2.86c-1.32-1.74-3.48-2.66-5.1-4.29a8,8,0,0,1-1.77-3,20.86,20.86,0,0,1-.8-3.63c-.35-2.49-.71-5.28-2.38-7.57a5.57,5.57,0,0,0-3.43-2.21,12.4,12.4,0,0,0-4,.1,14.06,14.06,0,0,1-3.69.22,4.76,4.76,0,0,1-3-1.56c-1.55-1.67-2.44-3.92-4.34-5.07A7.26,7.26,0,0,0,64.05,11a6.4,6.4,0,0,0-3.78,2.94,7,7,0,0,0-1,3.49,6,6,0,0,0,.36,2.27,3.86,3.86,0,0,0,.33.73s-.1-.26-.25-.76a6.64,6.64,0,0,1-.28-2.23,7.21,7.21,0,0,1,1-3.38,6.11,6.11,0,0,1,3.65-2.76,6.92,6.92,0,0,1,5.45.8,7.89,7.89,0,0,1,2.19,2.26,26.149,26.149,0,0,0,2.06,2.78,5.6,5.6,0,0,0,1.45,1.13,5.39,5.39,0,0,0,1.8.56,14.69,14.69,0,0,0,3.8-.21,11.89,11.89,0,0,1,3.81-.09,5.1,5.1,0,0,1,3.16,2,10.4,10.4,0,0,1,1.62,3.55,36.3,36.3,0,0,1,.69,3.81A20.79,20.79,0,0,0,91,31.63a8.09,8.09,0,0,0,1.88,3.14c1.71,1.7,3.85,2.6,5.1,4.24a5.82,5.82,0,0,1,1.08,2.7c.16.94.22,1.88.43,2.76a4.28,4.28,0,0,0,1.2,2.28,5.75,5.75,0,0,0,2,1.11,14.18,14.18,0,0,1,1.81.73,2.83,2.83,0,0,1,1.17,1.06,2.22,2.22,0,0,1,.3,2.11,1.75,1.75,0,0,1-.54.56Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7739",
    "data-name": "Path 7739",
    d: "M133.27,130.41l-20.12-1.84S100.77,96,85.5,88.05l-9.88,17.27,21.16,39.76H138.1Z",
    fill: "#7d0384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7740",
    "data-name": "Path 7740",
    d: "M133.27,130.41l-20.12-1.84S100.77,96,85.5,88.05l-9.88,17.27,21.16,39.76H138.1Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7741",
    "data-name": "Path 7741",
    d: "M125.32,139.62a16.06,16.06,0,0,0-1.7-3.26,14.78,14.78,0,0,0-2.07-3,15.85,15.85,0,0,0,1.7,3.25,15.931,15.931,0,0,0,2.07,3.01Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7742",
    "data-name": "Path 7742",
    d: "M111.06,139.23a15.21,15.21,0,0,0,2.46-2.72,15,15,0,0,0,2.12-3,15.8,15.8,0,0,0-2.46,2.71,15.641,15.641,0,0,0-2.12,3.01Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7743",
    "data-name": "Path 7743",
    d: "M108.59,131.75a8.15,8.15,0,0,0,.22-2.64,8.15,8.15,0,0,0-.22-2.64,8.15,8.15,0,0,0-.22,2.64,8.15,8.15,0,0,0,.22,2.64Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7744",
    "data-name": "Path 7744",
    d: "M115.67,143.41a5.51,5.51,0,0,0,1.92-1c1-.65,1.76-1.26,1.69-1.36a5.51,5.51,0,0,0-1.92,1C116.36,142.7,115.6,143.31,115.67,143.41Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7745",
    "data-name": "Path 7745",
    d: "M104.12,113.43a17.33,17.33,0,0,0,1.39,3.64,17.349,17.349,0,0,0,1.78,3.45,17.37,17.37,0,0,0-1.39-3.63,17.27,17.27,0,0,0-1.78-3.46Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7746",
    "data-name": "Path 7746",
    d: "M96,100.22c-.07.09.65.76,1.61,1.49a5.7,5.7,0,0,0,1.87,1.14c.07-.1-.65-.76-1.61-1.49A5.4,5.4,0,0,0,96,100.22Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7747",
    "data-name": "Path 7747",
    d: "M65.87,142.51,55.49,100.6A14.25,14.25,0,0,0,39.13,90h0a14.25,14.25,0,0,0-11.56,16.22l6.35,41a20.5,20.5,0,0,0,17,16.58l8.25,1.2Z",
    fill: "#7d0384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7748",
    "data-name": "Path 7748",
    d: "M33.17,87.28a9.44,9.44,0,0,1,3.7-1.86,9.87,9.87,0,0,1,4.46,0A12.13,12.13,0,0,1,46.19,88,23.53,23.53,0,0,1,52,96.17c.56,1.18,1,2.15,1.28,2.81a5.35,5.35,0,0,0,.51,1,5.56,5.56,0,0,0-.35-1.08c-.26-.69-.64-1.68-1.16-2.88A32.609,32.609,0,0,0,50.16,92a18.5,18.5,0,0,0-3.69-4.3,12.25,12.25,0,0,0-5-2.58,9.85,9.85,0,0,0-4.64.06A8,8,0,0,0,34,86.48a7.059,7.059,0,0,0-.63.57C33.22,87.19,33.16,87.27,33.17,87.28Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7749",
    "data-name": "Path 7749",
    d: "M92,96.71a2,2,0,0,0,.29.39l.89,1.07c.77.92,1.87,2.27,3.11,4a42.85,42.85,0,0,1,7.09,15c1.45,6.39,1.52,12.37,1.76,16.66.11,2.15.21,3.89.3,5.09q.08.84.12,1.38a4,4,0,0,0,.07.48,1.86,1.86,0,0,0,0-.49v-1.38c0-1.26-.09-3-.16-5.09-.17-4.29-.19-10.3-1.65-16.75A41.37,41.37,0,0,0,96.49,102c-1.29-1.73-2.42-3.06-3.23-4a8.422,8.422,0,0,0-1-1,2.231,2.231,0,0,0-.26-.29Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    "data-name": "Path 7750",
    d: "M25.46,96.62C26.59,89.13,30.73,87.33,35,85c1.4-.77,8.16-2.5,13.52-3.81.51-3.24,1.42-9,1.63-10.28.28-1.72,27.28,2.59,27.63,3.23.22.43.84,7.16,1.24,11.65l6.46,2.26,8.44,10.73L98.33,105a33.54,33.54,0,0,1,5.44,12A64.91,64.91,0,0,1,105,131.5l1.29,27.5-56.5,16-4.38-27.87L30.83,127.28C29.59,119.25,24.06,105.84,25.46,96.62Z",
    fill: "#7d0384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7751",
    "data-name": "Path 7751",
    d: "M73.68,86.65a8.57,8.57,0,0,0,.38-1.91c.17-1.18.39-2.82.6-4.64.1-.9.19-1.75.28-2.56a19.3,19.3,0,0,0,.15-2.12,2.6,2.6,0,0,0-.4-1.41c-.22-.28-.41-.36-.42-.34s.12.15.27.43a2.7,2.7,0,0,1,.24,1.32,19.155,19.155,0,0,1-.24,2.07c-.1.79-.2,1.66-.31,2.56-.21,1.82-.38,3.46-.48,4.66a8.48,8.48,0,0,0-.07,1.94Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7752",
    "data-name": "Path 7752",
    d: "M66.48,85a6.45,6.45,0,0,0,.6-1.75,27.64,27.64,0,0,0,.76-4.39,27,27,0,0,0,0-4.46,6.07,6.07,0,0,0-.27-1.82c-.13,0,.11,2.81-.21,6.24S66.35,84.91,66.48,85Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7753",
    "data-name": "Path 7753",
    d: "M53.07,83a27.66,27.66,0,0,1,.15-6.21,28,28,0,0,1,2-5.91,5.62,5.62,0,0,0-1,1.57,15.86,15.86,0,0,0-1.39,4.26,16.14,16.14,0,0,0-.13,4.48A5.48,5.48,0,0,0,53.07,83Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7754",
    "data-name": "Path 7754",
    d: "M91.44,107.51A15.49,15.49,0,0,0,89.22,104a15.55,15.55,0,0,0-2.74-3.1,26.769,26.769,0,0,0,2.4,3.36,26.27,26.27,0,0,0,2.56,3.25Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7755",
    "data-name": "Path 7755",
    d: "M78.71,97.15A13.19,13.19,0,0,0,81,94.57a14.3,14.3,0,0,0,1.9-2.84,13.19,13.19,0,0,0-2.25,2.58,14.3,14.3,0,0,0-1.94,2.84Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7756",
    "data-name": "Path 7756",
    d: "M65.41,90.65a25.919,25.919,0,0,0,2.66,2.69,23.85,23.85,0,0,0,2.75,2.58A12.4,12.4,0,0,0,68.37,93a12.56,12.56,0,0,0-2.96-2.35Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7757",
    "data-name": "Path 7757",
    d: "M69.14,82.72a8,8,0,0,0,2.08-1.59A7.87,7.87,0,0,0,73,79.22a8,8,0,0,0-2.08,1.59,8.07,8.07,0,0,0-1.78,1.91Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7758",
    "data-name": "Path 7758",
    d: "M57.49,76.5a9.9,9.9,0,0,0,2.8.83,10,10,0,0,0,2.9.39,10.51,10.51,0,0,0-2.81-.82,10.59,10.59,0,0,0-2.89-.4Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7759",
    "data-name": "Path 7759",
    d: "M55.16,95a10,10,0,0,0,.36-2.9,10.08,10.08,0,0,0-.07-2.93A10.13,10.13,0,0,0,55.09,92,10,10,0,0,0,55.16,95Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7760",
    "data-name": "Path 7760",
    d: "M59.41,103.83a16.31,16.31,0,0,0,1.46-3.37,16,16,0,0,0,1.05-3.52,15.7,15.7,0,0,0-1.46,3.37,16,16,0,0,0-1.05,3.52Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7761",
    "data-name": "Path 7761",
    d: "M71,110.08a17,17,0,0,0,1.6-3.52,17.2,17.2,0,0,0,1.2-3.69,17.63,17.63,0,0,0-1.6,3.53,17.919,17.919,0,0,0-1.2,3.68Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7762",
    "data-name": "Path 7762",
    d: "M81.82,117.17a15.77,15.77,0,0,0,.93-3.49,14.93,14.93,0,0,0,.51-3.58,16,16,0,0,0-.93,3.5,14.94,14.94,0,0,0-.51,3.57Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7763",
    "data-name": "Path 7763",
    d: "M94.73,117.46a15.461,15.461,0,0,0,1.74-3.09,15.12,15.12,0,0,0,1.36-3.28,14.659,14.659,0,0,0-1.75,3.09A14,14,0,0,0,94.73,117.46Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7764",
    "data-name": "Path 7764",
    d: "M95,125.73a17.61,17.61,0,0,0,3.39,1.92,17.9,17.9,0,0,0,3.57,1.52,17.231,17.231,0,0,0-3.38-1.91A17.31,17.31,0,0,0,95,125.73Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7765",
    "data-name": "Path 7765",
    d: "M94.84,138.83a9.24,9.24,0,0,0,1.18-3,9.42,9.42,0,0,0,.49-3.22,18.06,18.06,0,0,0-.91,3.1A18.251,18.251,0,0,0,94.84,138.83Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7766",
    "data-name": "Path 7766",
    d: "M97.51,148a14.31,14.31,0,0,0,2.72-2.2,14.39,14.39,0,0,0,2.43-2.51,14,14,0,0,0-2.72,2.19A14.24,14.24,0,0,0,97.51,148Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7767",
    "data-name": "Path 7767",
    d: "M80.5,141.75c0,.12,1.89.67,4.12,1.66s3.93,2,4,1.9a12.67,12.67,0,0,0-3.83-2.3,12.861,12.861,0,0,0-4.29-1.26Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7768",
    "data-name": "Path 7768",
    d: "M85.48,137.19a11.37,11.37,0,0,0,1.22-2.85,11.74,11.74,0,0,0,.82-3,11.18,11.18,0,0,0-1.23,2.85,11.45,11.45,0,0,0-.81,3Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7769",
    "data-name": "Path 7769",
    d: "M75.39,125.93a25.3,25.3,0,0,0,2.28,4,24.39,24.39,0,0,0,2.65,3.8,24.65,24.65,0,0,0-2.28-4,25,25,0,0,0-2.65-3.8Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7770",
    "data-name": "Path 7770",
    d: "M64.55,127a17.58,17.58,0,0,0,2.77-3.79,16.65,16.65,0,0,0,2-4.22c-.11,0-1.08,1.8-2.41,4A39.41,39.41,0,0,0,64.55,127Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7771",
    "data-name": "Path 7771",
    d: "M58.05,116.31a8.48,8.48,0,0,0,3.18.56,8.7,8.7,0,0,0,3.21-.24,19.839,19.839,0,0,0-3.19-.19A22,22,0,0,0,58.05,116.31Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7772",
    "data-name": "Path 7772",
    d: "M42.64,104.12a23.89,23.89,0,0,0,4.08,2.19A24.531,24.531,0,0,0,51,108.1a24.9,24.9,0,0,0-4.08-2.19,25.51,25.51,0,0,0-4.28-1.79Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7773",
    "data-name": "Path 7773",
    d: "M41.61,96.37a16.45,16.45,0,0,0-1.46-3.44,16,16,0,0,0-1.85-3.24,16.21,16.21,0,0,0,1.46,3.44A16,16,0,0,0,41.61,96.37Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7774",
    "data-name": "Path 7774",
    d: "M31.81,102.45a26.909,26.909,0,0,0,1.27-3.79,29.18,29.18,0,0,0,1.12-3.83,13.69,13.69,0,0,0-1.54,3.7,14.53,14.53,0,0,0-.85,3.92Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7775",
    "data-name": "Path 7775",
    d: "M30.28,110.52a12.89,12.89,0,0,0,3.65,1.33,12.84,12.84,0,0,0,3.85.59,28.471,28.471,0,0,0-3.74-1,28.7,28.7,0,0,0-3.76-.92Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7776",
    "data-name": "Path 7776",
    d: "M47.06,120.36c.13,0-.23-2-.33-4.57s.07-4.58-.06-4.59a13.63,13.63,0,0,0-.37,4.61A13.87,13.87,0,0,0,47.06,120.36Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7777",
    "data-name": "Path 7777",
    d: "M50.41,130.5a14.07,14.07,0,0,0,3.05-3,14.34,14.34,0,0,0,2.37-3.5,41.581,41.581,0,0,0-2.7,3.27A34.5,34.5,0,0,0,50.41,130.5Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7778",
    "data-name": "Path 7778",
    d: "M33.58,128.36a17.119,17.119,0,0,0,3.47,1.69,17.61,17.61,0,0,0,3.64,1.29,17.12,17.12,0,0,0-3.47-1.69A17.83,17.83,0,0,0,33.58,128.36Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7779",
    "data-name": "Path 7779",
    d: "M39.61,147.44a25.14,25.14,0,0,0,.17-4.59,25,25,0,0,0-.26-4.58,24,24,0,0,0-.17,4.59,24,24,0,0,0,.26,4.58Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7780",
    "data-name": "Path 7780",
    d: "M52.53,146.34a17.29,17.29,0,0,0-.74-4.71,17.72,17.72,0,0,0-1.57-4.5c-.11,0,.52,2.07,1.15,4.61A47.412,47.412,0,0,0,52.53,146.34Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7781",
    "data-name": "Path 7781",
    d: "M51.94,151.35c0,.12,2.07.32,4.6.74a46,46,0,0,0,4.6.77,17.239,17.239,0,0,0-4.53-1.2,16.47,16.47,0,0,0-4.67-.31Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7782",
    "data-name": "Path 7782",
    d: "M66.23,148.14a16.12,16.12,0,0,0-2.47-2.87A16.83,16.83,0,0,0,61,142.7a17.079,17.079,0,0,0,2.47,2.87,17.3,17.3,0,0,0,2.76,2.57Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7783",
    "data-name": "Path 7783",
    d: "M75.49,157.15a28.352,28.352,0,0,0,1.13-3.26,31.272,31.272,0,0,0,1.16-3.25A13.39,13.39,0,0,0,75.49,157.15Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7784",
    "data-name": "Path 7784",
    d: "M60.55,162.29a23.058,23.058,0,0,0,4.18-1.61,23.4,23.4,0,0,0,4-2,23.6,23.6,0,0,0-4.18,1.62,23,23,0,0,0-4,1.99Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7785",
    "data-name": "Path 7785",
    d: "M86.6,160.78a22.7,22.7,0,0,0-2-6,11.87,11.87,0,0,0,.78,3.05A11.61,11.61,0,0,0,86.6,160.78Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7786",
    "data-name": "Path 7786",
    d: "M69.44,163.69c0,.12,2.39-.26,5.33-.41s5.35,0,5.36-.16a18.78,18.78,0,0,0-5.38-.27A18.609,18.609,0,0,0,69.44,163.69Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7787",
    "data-name": "Path 7787",
    d: "M65.87,139.12a1.19,1.19,0,0,0,0-.33,3.17,3.17,0,0,0-.13-.94,2.09,2.09,0,0,0-.91-1.24,3,3,0,0,0-2-.34l.17.1c-.92-3.19-2.37-7.86-3.83-13.09-1.36-4.9-2.28-9.41-2.93-12.68-.31-1.58-.57-2.89-.76-3.87a10,10,0,0,0-.33-1.41,9.491,9.491,0,0,0,.16,1.44c.13.92.34,2.25.63,3.9.57,3.28,1.44,7.82,2.81,12.73,1.46,5.25,3,9.9,4,13.07v.12h.13a2.68,2.68,0,0,1,1.85.24,2,2,0,0,1,.88,1.1C65.86,138.66,65.81,139.13,65.87,139.12Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7788",
    "data-name": "Path 7788",
    d: "M47.19,150.71c.07,0,.58-1.1,1.64-2.78a28.77,28.77,0,0,1,11.33-10.3c1.78-.89,3-1.29,2.92-1.37a3.26,3.26,0,0,0-.84.22,17.689,17.689,0,0,0-2.21.88,25.87,25.87,0,0,0-11.46,10.41,18.608,18.608,0,0,0-1.08,2.12,3.28,3.28,0,0,0-.3.82Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13681",
    "data-name": "Group 13681",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7789",
    "data-name": "Path 7789",
    d: "M62.62,135.65a29.349,29.349,0,0,0-8.79,1.59,11.252,11.252,0,0,0-6.85,6.26,2.07,2.07,0,0,0,.15,2.17,1.55,1.55,0,0,0,1.58.25,4.21,4.21,0,0,0,1.38-.95c1.84-1.7,3.74-3.2,5.64-4.83a15.9,15.9,0,0,1,7.12-3.73"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7790",
    "data-name": "Path 7790",
    d: "M68.62,130.33a3.56,3.56,0,0,0,.87.51,14.64,14.64,0,0,0,2.56,1,17.1,17.1,0,0,0,16.78-4.35,15.74,15.74,0,0,0,1.77-2.09,4.06,4.06,0,0,0,.51-.87,30.129,30.129,0,0,1-2.49,2.74,17.67,17.67,0,0,1-16.49,4.28,37,37,0,0,1-3.51-1.22Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13682",
    "data-name": "Group 13682",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7791",
    "data-name": "Path 7791",
    d: "M90.66,125.14c-1.4,3-3,6.12-5.71,8.17a9.14,9.14,0,0,1-5.26,2.2c-2.78.05-5.17-1.85-7.29-3.65,6.87,1.08,14.62-2,18.26-6.72"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7792",
    "data-name": "Path 7792",
    d: "M59.86,84.31c.13,0,0-2.86.31-6.35s1-6.26.9-6.29a6.86,6.86,0,0,0-.58,1.78,31.911,31.911,0,0,0-.75,4.47,31.5,31.5,0,0,0-.11,4.53,6.44,6.44,0,0,0,.23,1.86Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7793",
    "data-name": "Path 7793",
    d: "M158.68,195.8s9,1.95,17.13.74c7.58-1.13,24.55,0,24.54,10,0,11.14-22.63,8.39-31.46,6.62s-17.62-3.36-17.62-3.36Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7794",
    "data-name": "Path 7794",
    d: "M179,210.07a19.651,19.651,0,0,0,1.09-3.88,18.35,18.35,0,0,0,.67-4,37.78,37.78,0,0,0-1.76,7.85Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7795",
    "data-name": "Path 7795",
    d: "M175.91,210.22a19.068,19.068,0,0,0,.76-4,18.631,18.631,0,0,0,.34-4,36.8,36.8,0,0,0-1.1,8Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7796",
    "data-name": "Path 7796",
    d: "M172.93,209.05a14.4,14.4,0,0,0,.63-3.47,14.18,14.18,0,0,0,.21-3.53,14.841,14.841,0,0,0-.64,3.48A14.37,14.37,0,0,0,172.93,209.05Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7797",
    "data-name": "Path 7797",
    d: "M168.24,207.88a7.91,7.91,0,0,0,1.17-3,8.17,8.17,0,0,0,.33-3.18,22.743,22.743,0,0,0-.75,3.08,24.333,24.333,0,0,0-.75,3.1Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7798",
    "data-name": "Path 7798",
    d: "M167.24,203.81a4,4,0,0,0-1.18-.08,10.1,10.1,0,0,0-3.18.62,3.61,3.61,0,0,0-1,.53,1.52,1.52,0,0,0-.62,1.1,1.67,1.67,0,0,0,2.05,1.49,4.18,4.18,0,0,0,2.37-1.68A7.34,7.34,0,0,0,167,203a7.12,7.12,0,0,0-1-5.77,1.16,1.16,0,0,0-.67-.41.94.94,0,0,0-.76.24,2,2,0,0,0-.56,1.21,6,6,0,0,0,.12,2.27,6.31,6.31,0,0,0,1.52,2.86,5.281,5.281,0,0,0,.66.58c.17.12.26.17.27.16s-.32-.28-.8-.85a6.55,6.55,0,0,1-1.35-2.82,5.83,5.83,0,0,1-.07-2.14,1.65,1.65,0,0,1,.47-1,.58.58,0,0,1,.87.14,7.07,7.07,0,0,1-.38,8,3.84,3.84,0,0,1-2.1,1.55,1.31,1.31,0,0,1-1.62-1.09,1.21,1.21,0,0,1,.47-.85,3.081,3.081,0,0,1,.88-.5,10.87,10.87,0,0,1,3.08-.74A7.509,7.509,0,0,0,167.24,203.81Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7799",
    "data-name": "Path 7799",
    d: "M152.17,208.35a.81.81,0,0,0,.23.07l.67.17,2.63.6c2.28.5,5.6,1.21,9.71,2s9,1.7,14.55,2.45a39,39,0,0,0,8.73.43,18.8,18.8,0,0,0,4.58-.87,12.321,12.321,0,0,0,2.2-1,6.9,6.9,0,0,0,1.93-1.55h0a4.53,4.53,0,0,0,.79-.94,5.86,5.86,0,0,0,.46-4.88,7.74,7.74,0,0,0-2.9-3.79,14.59,14.59,0,0,0-4.13-2c-.72-.21-1.42-.46-2.14-.62s-1.42-.33-2.13-.43c-5.67-.9-10.83-.44-15.12-.44-2.15,0-4.09,0-5.8-.12a40.73,40.73,0,0,1-4.33-.55l-1.56-.33-1.13-.32-.69-.19-.24-.05a1,1,0,0,0,.22.09l.69.23,1.12.36,1.56.37a34.611,34.611,0,0,0,4.35.63c1.7.13,3.66.21,5.81.19,4.3,0,9.46-.39,15.06.52.7.1,1.39.29,2.1.44s1.39.4,2.1.61a14.31,14.31,0,0,1,4,2A7.41,7.41,0,0,1,198.2,205a5.44,5.44,0,0,1-.41,4.51,4.27,4.27,0,0,1-.71.85h0a6.64,6.64,0,0,1-1.79,1.43,12.809,12.809,0,0,1-2.11.94,18.38,18.38,0,0,1-4.48.86,39.092,39.092,0,0,1-8.65-.41c-5.5-.72-10.42-1.6-14.54-2.34s-7.44-1.42-9.74-1.87l-2.64-.52-.68-.13Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7800",
    "data-name": "Path 7800",
    d: "M185.28,213.72a16.778,16.778,0,0,0,.22-2.32c.1-1.43.27-3.39.56-5.56s.64-4.11.92-5.51a16.29,16.29,0,0,0,.4-2.29,9.92,9.92,0,0,0-.7,2.22,51.28,51.28,0,0,0-1.49,11.13,9.84,9.84,0,0,0,.09,2.33Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7801",
    "data-name": "Path 7801",
    d: "M161.46,196.28l-5.74,14.37-4.45-.82,8.53-14.03Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7802",
    "data-name": "Path 7802",
    d: "M86.69,156.89c.92.31,60.21-16.31,84.19-23a22.75,22.75,0,0,1,18.54,2.81l.29.18a22.79,22.79,0,0,1,9.81,24.29h0a22.77,22.77,0,0,1-10.28,14.26c-15.81,9.68-49.28,30.06-50.3,29.67-1.34-.52-43.13-1.61-43.13-1.61l50.27-36.15-23.91,15.45Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7803",
    "data-name": "Path 7803",
    d: "M136.19,138.85l-12.6-6.52-12.36,7.74L65,141.59l-6.7,22.53,67-15.53s12.19,1.08,13.1-1.66S136.19,138.85,136.19,138.85Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7804",
    "data-name": "Path 7804",
    d: "M98.28,175l6.23,20.46-.78,6.23h0a32,32,0,0,1-42.22,2.85h0a31.35,31.35,0,0,1-12.26-25l.09-21.38Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7805",
    "data-name": "Path 7805",
    d: "M135.38,175.08c.07.1,7.3-5.17,16.15-11.77s16-12,15.89-12.13-7.3,5.18-16.15,11.78S135.31,175,135.38,175.08Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7806",
    "data-name": "Path 7806",
    d: "M124.43,136.41a51,51,0,0,0,6.17,2.2,46.767,46.767,0,0,0,6.3,1.79,51,51,0,0,0-6.17-2.2,50.628,50.628,0,0,0-6.3-1.79Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7807",
    "data-name": "Path 7807",
    d: "M123.49,140.25a12.441,12.441,0,0,0,2.15.41c1.33.21,3.15.54,5.15,1s3.79,1,5.07,1.35a13.44,13.44,0,0,0,2.11.57,9.94,9.94,0,0,0-2-.87,46.57,46.57,0,0,0-5.07-1.48,45.2,45.2,0,0,0-5.21-.88A9.84,9.84,0,0,0,123.49,140.25Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7808",
    "data-name": "Path 7808",
    d: "M124.55,143.78a59.568,59.568,0,0,0,6.94,1.59,60.517,60.517,0,0,0,7,1.18,56.591,56.591,0,0,0-6.94-1.6A56.739,56.739,0,0,0,124.55,143.78Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7809",
    "data-name": "Path 7809",
    d: "M140.9,108.62l-11.63,38.26a1.09,1.09,0,0,1-1,.78L96.61,150a1.1,1.1,0,0,0-1,1.1v2a1.11,1.11,0,0,0,1.13,1.11l86.6-1.63a1.11,1.11,0,0,0,1-.71L199.57,112a1.11,1.11,0,0,0-1-1.51L142,107.84a1.1,1.1,0,0,0-1.1.78Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7810",
    "data-name": "Path 7810",
    d: "M165.3,125.11a2.72,2.72,0,0,1,1.72,1.94,2.62,2.62,0,0,1-1.12,2.39,2.86,2.86,0,0,1-3.17.11,2.63,2.63,0,0,1-.86-3.19,2.84,2.84,0,0,1,3.43-1.25",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7811",
    "data-name": "Path 7811",
    d: "M151.27,209.83l9.16-15.06L93.11,142a27.17,27.17,0,0,0-14.7-6h0A27.06,27.06,0,0,0,49,165.17L50.08,178l44.68,14.4Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7812",
    "data-name": "Path 7812",
    d: "M65,174.07s0,.06.18.17l.55.45,2.14,1.71,1.56,1.23c.57.45,1.24.87,1.93,1.36s1.44,1,2.23,1.53c.4.27.8.55,1.23.83l1.33.8c1.83,1.1,3.81,2.35,6.05,3.48,1.11.58,2.24,1.21,3.43,1.8l3.72,1.76c5.13,2.34,10.87,4.69,17,6.78,12.3,4.24,23.66,7.29,31.8,9.76,2,.6,3.89,1.16,5.5,1.67s3,.93,4.13,1.31l2.6.85.68.21.24.06a.9.9,0,0,0-.22-.1l-.67-.25-2.58-.93c-1.12-.41-2.5-.86-4.11-1.38s-3.44-1.12-5.48-1.74c-8.12-2.54-19.47-5.64-31.75-9.87-6.14-2.09-11.87-4.42-17-6.73l-3.72-1.74c-1.19-.58-2.33-1.21-3.44-1.78-2.23-1.11-4.21-2.35-6-3.42l-1.34-.79-1.23-.81-2.25-1.5c-.69-.48-1.37-.89-1.94-1.33l-1.58-1.19-2.19-1.65-.57-.42Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7813",
    "data-name": "Path 7813",
    d: "M63.32,181.11a6.068,6.068,0,0,0,.68.36c.45.21,1.1.47,1.93.78a49.11,49.11,0,0,0,13.4,2.88c.88.06,1.59.08,2.08.08a2.51,2.51,0,0,0,.77-.05c0-.06-1.08-.14-2.82-.34a68,68,0,0,1-6.74-1.09C70,183.17,67.69,182.49,66,182a26.865,26.865,0,0,0-2.68-.89Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7814",
    "data-name": "Path 7814",
    d: "M95.81,144.54c-.08.1,14.33,11.42,32.17,25.28s32.37,25,32.45,25-14.34-11.42-32.18-25.29S95.88,144.45,95.81,144.54Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7815",
    "data-name": "Path 7815",
    d: "M99.7,200.52c3.23-1.72,6.85-.7,9.94.34,2.06.69,4.19,1.79,6.28,1.2,1.51-.42,2.63-1.65,3.79-2.71a23.79,23.79,0,0,1,17.4-6.23,7.06,7.06,0,0,1,4.78,2.16c3.17,3.43.78,7.9-2.06,10.79a31.28,31.28,0,0,1-18.92,9.13c-5.91.61-14-.2-20-2.77-3.69-1.58-5.58-5.93-3.64-9.45A6,6,0,0,1,99.7,200.52Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13683",
    "data-name": "Group 13683",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7816",
    "data-name": "Path 7816",
    d: "M99.7,203.27c3.23-1.72,6.86-.7,10,.34,2,.69,4.19,1.79,6.28,1.2,1.51-.42,2.63-1.65,3.79-2.71a23.77,23.77,0,0,1,17.4-6.23,7,7,0,0,1,4.77,2.16,5.53,5.53,0,0,1,1.34,2.4,12.54,12.54,0,0,1-3.39,5.64,31.31,31.31,0,0,1-18.92,9.13c-5.91.61-14-.2-20-2.77a7.3,7.3,0,0,1-4.26-5.07,6.33,6.33,0,0,1,.61-1.63,6.11,6.11,0,0,1,2.38-2.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7817",
    "data-name": "Path 7817",
    d: "M96.64,207.36a5.86,5.86,0,0,1,.79-1.92,6.47,6.47,0,0,1,1.73-1.68,6.85,6.85,0,0,1,3-1.14c2.4-.28,5.17.73,8.26,1.56a12.8,12.8,0,0,0,5,.79,6.52,6.52,0,0,0,2.57-.89,15,15,0,0,0,2.22-1.67,24.1,24.1,0,0,1,13.23-6.27,14.171,14.171,0,0,1,3.9,0,8.52,8.52,0,0,1,3,1.06,7.7,7.7,0,0,1,1.85,1.57,16.46,16.46,0,0,1,1.19,1.72,6.71,6.71,0,0,0-1.06-1.83,7.58,7.58,0,0,0-1.86-1.67,8.6,8.6,0,0,0-3.1-1.15,13.67,13.67,0,0,0-4,0,22.56,22.56,0,0,0-4.47,1,26.84,26.84,0,0,0-4.64,2.05A18.44,18.44,0,0,0,122,200.3c-.72.56-1.4,1.18-2.1,1.78a15.689,15.689,0,0,1-2.16,1.63,6,6,0,0,1-2.41.84,12.64,12.64,0,0,1-4.86-.75c-3.07-.81-5.89-1.81-8.4-1.49a7,7,0,0,0-4.8,3,4.86,4.86,0,0,0-.6,1.46,2.08,2.08,0,0,0-.03.59Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7818",
    "data-name": "Path 7818",
    d: "M96.64,207.36a5.86,5.86,0,0,1,.79-1.92,6.47,6.47,0,0,1,1.73-1.68,6.85,6.85,0,0,1,3-1.14c2.4-.28,5.17.73,8.26,1.56a12.8,12.8,0,0,0,5,.79,6.52,6.52,0,0,0,2.57-.89,15,15,0,0,0,2.22-1.67,24.1,24.1,0,0,1,13.23-6.27,14.171,14.171,0,0,1,3.9,0,8.52,8.52,0,0,1,3,1.06,7.7,7.7,0,0,1,1.85,1.57,16.46,16.46,0,0,1,1.19,1.72,6.71,6.71,0,0,0-1.06-1.83,7.58,7.58,0,0,0-1.86-1.67,8.6,8.6,0,0,0-3.1-1.15,13.67,13.67,0,0,0-4,0,22.56,22.56,0,0,0-4.47,1,26.84,26.84,0,0,0-4.64,2.05A18.44,18.44,0,0,0,122,200.3c-.72.56-1.4,1.18-2.1,1.78a15.689,15.689,0,0,1-2.16,1.63,6,6,0,0,1-2.41.84,12.64,12.64,0,0,1-4.86-.75c-3.07-.81-5.89-1.81-8.4-1.49a7,7,0,0,0-4.8,3,4.86,4.86,0,0,0-.6,1.46,2.08,2.08,0,0,0-.03.59Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7819",
    "data-name": "Path 7819",
    d: "M136.69,206.58a8.439,8.439,0,0,0-1.66-1.15c-1.06-.64-2.56-1.47-4.27-2.28a47.016,47.016,0,0,0-4.49-1.84,8.731,8.731,0,0,0-1.94-.54,11,11,0,0,0,1.83.83c1.14.48,2.71,1.14,4.41,1.94s3.22,1.59,4.31,2.16a10.381,10.381,0,0,0,1.81.88Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7820",
    "data-name": "Path 7820",
    d: "M135.58,209.81a58.132,58.132,0,0,0-6.31-3.29,57.779,57.779,0,0,0-6.49-2.9,57.349,57.349,0,0,0,6.3,3.29,58.338,58.338,0,0,0,6.5,2.9Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7821",
    "data-name": "Path 7821",
    d: "M122.2,211.21c.07.1,3.51-2,7.69-4.58a66.5,66.5,0,0,0,7.45-5c-.06-.14-3.51,2-7.69,4.59A76.713,76.713,0,0,0,122.2,211.21Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7822",
    "data-name": "Path 7822",
    d: "M120.27,207.86a10.742,10.742,0,0,0,1.68-1.13c1-.73,2.41-1.73,4-2.82s3-2,4-2.73A10.189,10.189,0,0,0,131.6,200a8.429,8.429,0,0,0-1.8.92c-1.09.63-2.56,1.55-4.13,2.64s-2.94,2.14-3.91,2.93A8.2,8.2,0,0,0,120.27,207.86Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1410",
    "data-name": "Ellipse 1410",
    cx: 5.94,
    cy: 5.94,
    r: 5.94,
    transform: "translate(150.01 80.49)",
    fill: "#fc9702"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7823",
    "data-name": "Path 7823",
    d: "M174.62,87.57h-2.2v2.24h-2.09V87.57h-2.2v-2h2.2V83.33h2.09v2.25h2.2Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7824",
    "data-name": "Path 7824",
    d: "M177.62,84.07V82h3.63v9H179V84.07Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7825",
    "data-name": "Path 7825",
    d: "M189.16,83.72h-4v1.82a1.87,1.87,0,0,1,.75-.48,3.09,3.09,0,0,1,1-.17,2.65,2.65,0,0,1,1.51.4,2.37,2.37,0,0,1,.9,1.08,3.56,3.56,0,0,1,.3,1.48,3.22,3.22,0,0,1-.83,2.33,3.07,3.07,0,0,1-2.32.86,4.05,4.05,0,0,1-1.77-.36,2.71,2.71,0,0,1-1.15-1,2.87,2.87,0,0,1-.44-1.5h2.12a1.26,1.26,0,0,0,.35.71,1.06,1.06,0,0,0,.79.28,1,1,0,0,0,.85-.37,1.55,1.55,0,0,0,.29-1,1.22,1.22,0,0,0-.31-.9,1.12,1.12,0,0,0-.85-.32,1.28,1.28,0,0,0-.7.19,1,1,0,0,0-.38.47h-2.11V81.82h6Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7826",
    "data-name": "Path 7826",
    d: "M190.7,86.43a5.69,5.69,0,0,1,.85-3.32,3.61,3.61,0,0,1,5.43,0,5.69,5.69,0,0,1,.86,3.32,5.78,5.78,0,0,1-.86,3.34,3.61,3.61,0,0,1-5.43,0,5.78,5.78,0,0,1-.85-3.34Zm5,0a4.7,4.7,0,0,0-.29-1.85,1.1,1.1,0,0,0-1.12-.64,1.15,1.15,0,0,0-1.15.65,4.679,4.679,0,0,0-.29,1.84,4.82,4.82,0,0,0,.29,1.86,1.13,1.13,0,0,0,1.15.65,1.09,1.09,0,0,0,1.12-.65,4.82,4.82,0,0,0,.27-1.86Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1411",
    "data-name": "Ellipse 1411",
    cx: 5.94,
    cy: 5.94,
    r: 5.94,
    transform: "translate(152.99 20.06)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7827",
    "data-name": "Path 7827",
    d: "M177.6,27.12h-2.2v2.24h-2.09V27.12h-2.2v-2h2.2V22.88h2.09v2.25h2.2Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7828",
    "data-name": "Path 7828",
    d: "M180.6,23.62v-2h3.63v9h-2.29v-7Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7829",
    "data-name": "Path 7829",
    d: "M185.51,26a5.71,5.71,0,0,1,.85-3.32,3.61,3.61,0,0,1,5.43,0,5.71,5.71,0,0,1,.86,3.32,5.76,5.76,0,0,1-.86,3.34,3.61,3.61,0,0,1-5.43,0,5.76,5.76,0,0,1-.85-3.34Zm5,0a4.55,4.55,0,0,0-.29-1.85,1.1,1.1,0,0,0-1.12-.64,1.12,1.12,0,0,0-1.14.65,4.5,4.5,0,0,0-.29,1.84,4.641,4.641,0,0,0,.29,1.86,1.11,1.11,0,0,0,1.14.65,1.09,1.09,0,0,0,1.12-.65,4.64,4.64,0,0,0,.27-1.86Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7830",
    "data-name": "Path 7830",
    d: "M193.69,26a5.79,5.79,0,0,1,.85-3.32,3.61,3.61,0,0,1,5.43,0,5.71,5.71,0,0,1,.86,3.32,5.76,5.76,0,0,1-.86,3.34,3.61,3.61,0,0,1-5.43,0,5.83,5.83,0,0,1-.85-3.34Zm5,0a4.73,4.73,0,0,0-.29-1.85,1.1,1.1,0,0,0-1.12-.64,1.12,1.12,0,0,0-1.14.65,4.5,4.5,0,0,0-.29,1.84,4.64,4.64,0,0,0,.29,1.86,1.11,1.11,0,0,0,1.14.65,1.09,1.09,0,0,0,1.12-.65,4.82,4.82,0,0,0,.27-1.86Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1412",
    "data-name": "Ellipse 1412",
    cx: 5.94,
    cy: 5.94,
    r: 5.94,
    transform: "translate(134.01 48.26)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7831",
    "data-name": "Path 7831",
    d: "M158.93,55.34h-2.19v2.23h-2.1V55.34h-2.2v-2h2.2V51.1h2.1v2.24h2.19Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7832",
    "data-name": "Path 7832",
    d: "M169,51.49h-4v1.82a1.59,1.59,0,0,1,.74-.48,3.13,3.13,0,0,1,1-.17,2.71,2.71,0,0,1,1.52.4,2.47,2.47,0,0,1,.9,1.07,3.81,3.81,0,0,1,.29,1.49,3.22,3.22,0,0,1-.83,2.33,3.07,3.07,0,0,1-2.32.86,3.91,3.91,0,0,1-1.77-.37,2.64,2.64,0,0,1-1.15-1,2.86,2.86,0,0,1-.43-1.49H165a1.23,1.23,0,0,0,.35.71,1.09,1.09,0,0,0,.78.28,1,1,0,0,0,.85-.37,1.51,1.51,0,0,0,.29-1,1.25,1.25,0,0,0-.3-.9,1.15,1.15,0,0,0-.86-.32,1.24,1.24,0,0,0-.69.18.92.92,0,0,0-.38.48H163V49.58h6Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7833",
    "data-name": "Path 7833",
    d: "M170.49,54.2a5.74,5.74,0,0,1,.85-3.33,3.63,3.63,0,0,1,5.43,0,5.74,5.74,0,0,1,.86,3.33,5.8,5.8,0,0,1-.86,3.34,3.61,3.61,0,0,1-5.43,0,5.8,5.8,0,0,1-.85-3.34Zm5,0a4.49,4.49,0,0,0-.29-1.85,1.1,1.1,0,0,0-1.12-.64,1.12,1.12,0,0,0-1.14.64,4.58,4.58,0,0,0-.29,1.85,4.64,4.64,0,0,0,.29,1.86,1.12,1.12,0,0,0,1.14.65,1.1,1.1,0,0,0,1.12-.65,4.64,4.64,0,0,0,.27-1.86Z",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17400",
    "data-name": "Rectangle 17400",
    width: 17.35,
    height: 0.52,
    transform: "translate(219.741 143.426) rotate(-35.41)",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17401",
    "data-name": "Rectangle 17401",
    width: 19.98,
    height: 0.52,
    transform: "matrix(0.448, -0.894, 0.894, 0.448, 226.748, 155.487)",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17402",
    "data-name": "Rectangle 17402",
    width: 13.45,
    height: 0.52,
    transform: "translate(328.952 40.28) rotate(-60.65)",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17403",
    "data-name": "Rectangle 17403",
    width: 19.1,
    height: 0.52,
    transform: "translate(334.454 39.248) rotate(-35.66)",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17404",
    "data-name": "Rectangle 17404",
    width: 0.52,
    height: 18.02,
    transform: "translate(341.371 101.82) rotate(-80.59)",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17405",
    "data-name": "Rectangle 17405",
    width: 0.52,
    height: 15.32,
    transform: "matrix(0.55, -0.835, 0.835, 0.55, 344.822, 104.955)",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7834",
    "data-name": "Path 7834",
    d: "M249.94,38.53l-.52-.08a36.221,36.221,0,0,0,0-9.49c-.55-3.71-1.73-6.48-3.55-8.29a9.52,9.52,0,0,1-.75,2.81,5.4,5.4,0,0,1-5,3.41,6.87,6.87,0,0,1-6.29-3.48,3.8,3.8,0,0,1,0-4c1.15-1.61,3.73-2.18,7.28-1.62a9.11,9.11,0,0,1,4.33,1.87,15.9,15.9,0,0,0-3.25-10.39l.41-.34A16.55,16.55,0,0,1,246,20c2.06,1.89,3.42,4.88,4,8.85a36.87,36.87,0,0,1-.06,9.68ZM234.49,19.41a1.709,1.709,0,0,0-.21.26,3.3,3.3,0,0,0,0,3.5,6.36,6.36,0,0,0,5.81,3.2,4.91,4.91,0,0,0,4.57-3.11,9.24,9.24,0,0,0,.76-3,8.6,8.6,0,0,0-4.36-2C237.92,17.77,235.61,18.18,234.49,19.41Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7835",
    "data-name": "Path 7835",
    d: "M358.69,74.39a3.61,3.61,0,0,1-2.93-.89c-2-1.71-2.42-5.29-1.18-9.12a15.348,15.348,0,0,1,.9-2.19,12,12,0,0,0-8.82,1.3,14.81,14.81,0,0,0-4.26,3.57l-.42-.32a15,15,0,0,1,4.4-3.7,12.8,12.8,0,0,1,9.35-1.33,13.06,13.06,0,0,1,10.2-7.13v.52a12.5,12.5,0,0,0-9.71,6.75,14.85,14.85,0,0,1,2,.7c4.24,1.83,4.91,4.58,4.93,6.07A6.11,6.11,0,0,1,359.86,74a4.111,4.111,0,0,1-1.17.39ZM356,62.32a14.222,14.222,0,0,0-.93,2.22c-1.18,3.63-.78,7,1,8.56a3.12,3.12,0,0,0,3.53.47,5.57,5.57,0,0,0,3-4.95c0-2.34-1.67-4.32-4.61-5.59a15.351,15.351,0,0,0-1.99-.71Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7836",
    "data-name": "Path 7836",
    d: "M333.13,101.36l-10.25-49.9-43.75,5.79L238,73.56l9.61,56.4,62-4.3Zm-23.67,23.45-9.77-58.29,22.72-13.87,10,48.49ZM279.31,57.93l42.3-5.61L299.19,66,241,73.18Zm-31.17,71.3-9.38-55.07L299,66.73l9.8,58.49Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7837",
    "data-name": "Path 7837",
    d: "M238.07,73.51l9.39,56.44,62.06-4-10-60.05Z",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7838",
    "data-name": "Path 7838",
    d: "M245.12,134.22l-3.92-22.11.52-.09,3.84,21.65,17.54-1.08.03.52Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7839",
    "data-name": "Path 7839",
    d: "M313.2,58,283,61.9l12.42-6.39-.4-.78-6.61,3.41a36.86,36.86,0,0,0,7.11-7.57c3.1-4.49,4.49-8.9,3.71-11.8-.6-2.22-2.43-3.33-5.15-3.14-4.46.32-8,4.9-10.66,13.63-.49,1.66-.9,3.31-1.24,4.86a38.13,38.13,0,0,0-2.2-11c-2-5.46-5-9.31-7.89-10-1.46-.37-4.17-.24-5.92,4.89-2,5.82,0,11.93,5.69,17.68a44.469,44.469,0,0,0,8.62,6.61h0L258.1,65.19l.11.87,20-2.58-12.08,6.21L276,128l.87-.15L267.1,70.11l13.65-7L312.5,59l10.25,52.74.86-.17Zm-31.1,1.54c1-6.47,4.23-22.48,12.08-23,2.28-.16,3.75.7,4.24,2.5.7,2.62-.67,6.86-3.59,11.07a36.55,36.55,0,0,1-12.95,11.32C282,60.78,282,60.16,282.1,59.54ZM267,38.21c.71-2.09,2-4.43,4.09-4.43a3.12,3.12,0,0,1,.78.11c4.79,1.22,10.49,13,9.35,25.44-.14.91-.24,1.64-.3,2.13A43.28,43.28,0,0,1,272.49,55C267,49.41,265.14,43.77,267,38.21Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7840",
    "data-name": "Path 7840",
    d: "M327.69,62.38,324.9,49.37l-7.03.83-.06-.52,7.5-.89,2.9,13.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7841",
    "data-name": "Path 7841",
    d: "M320.69,138l19,25.5,6.88-4.89,10.27,4.13,2.5-14.25,8.42-5.29Zm19.2,24.28-17-22.77,31.76,12.27Zm7.54-4.27,8.16-5.79.46,9.25Zm9.33.15-.31-6.54.07-.06-23.45-9.08,24.13,7.37,1.15-.73Zm.31-9.27L326.3,139.5l38.87,4.3Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7842",
    "data-name": "Path 7842",
    d: "M365.17,143.76l-8.1,5.09-30.77-9.39Z",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7843",
    "data-name": "Path 7843",
    d: "M354.68,151.74l-14.79,10.5-16.97-22.77Z",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1413",
    "data-name": "Ellipse 1413",
    cx: 15.93,
    cy: 15.93,
    r: 15.93,
    transform: "translate(244.59 154.66)",
    fill: "#fc9702"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7844",
    "data-name": "Path 7844",
    d: "M257.19,170.02l-1.4-3.7.52-.19,1.4,3.69Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7845",
    "data-name": "Path 7845",
    d: "M262.81,167.9l-1.4-3.7.52-.2,1.4,3.7Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7846",
    "data-name": "Path 7846",
    d: "M260.25,177.18A8.8,8.8,0,0,1,252,171.5l.52-.2a8.232,8.232,0,0,0,15.4-5.82l.52-.2a8.78,8.78,0,0,1-5.12,11.33,8.57,8.57,0,0,1-3.07.57Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17406",
    "data-name": "Rectangle 17406",
    width: 0.61,
    height: 21.45,
    transform: "translate(214.476 59.913) rotate(-81.03)",
    fill: "#af67b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17407",
    "data-name": "Rectangle 17407",
    width: 0.61,
    height: 21.52,
    transform: "matrix(0.568, -0.823, 0.823, 0.568, 211.054, 45.64)",
    fill: "#af67b4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationTrocadepontos);
export default __webpack_public_path__ + "static/media/illustration_troca de pontos.bb7073c3aa886e756461526908938094.svg";
export { ForwardRef as ReactComponent };